export enum Category {
  FILE = 0,
  PROCESS = 1,
  WEBSITE = 2,
  EMAIL = 3,
  APPLICATION = 4,
  CONNECTION = 5,
  DEVICE = 6,
  AMSI_OBJECTS = 7,
  UEFI_OBJECTS = 8,
}

export enum ActionTakenEnum {
  IGNORED = 1, // deprecated
  UNRESOLVED = 2,
  DELETED = 3,
  BLOCKED = 4,
  QUARANTINED = 5,
  REMEDIATED = 6,
  REPORTED = 7,
  ALLOWED = 8,
  MALICIOUS_PROCESS_KILLED = 9,
  DELETED_ATTACHMENT = 10,
  REPLACED_ATTACHMENT = 11,
  REJECTED_EMAIL = 12,
  READ_ONLY = 13,
  DELIVERED = 14,
  ENDPOINT_ISOLATED = 15,
  ENDPOINT_REBOOTED = 16,
  ENDPOINT_REBOOTED_AND_ISOLATED = 17,
  DENIED = 18,
}

export enum ThreatType {
  VIRUS = 1,
  SPYWARE = 2,
  ADWARE = 3,
  ROOTKIT = 4,
  DIALER = 5,
  POTENTIALLY_HARMFUL_APPLICATION = 6,
  ARCHIVE_BOMB = 7,
  PUA = 8,
  TARGETED_ATTACK = 9,
  EXPLOIT = 10,
  RANSOMWARE = 11,
  GREYWARE = 12,
  UNTRUSTED_FILE = 13,
  MALICIOUS_PROCESS = 14,
  ROP_EMULATION = 15,
  ROP_STACK_PIVOT = 16,
  ROP_ILLEGAL_CALL = 17,
  ROP_STACK_MISALIGNED = 18,
  ROP_RETURN_TO_STACK = 19,
  ROP_MAKE_STACK_EXECUTABLE = 20,
  SHELLCODE_THREAD = 21,
  FLASH_GENERIC = 22,
  FLASH_PAYLOAD = 23,
  SHELLCODE_EXECUTION = 24,
  SHELLCODE_LOADLIBRARY = 25,
  SHELLCODE_EAF = 26,
  OBSOLETE_PROCESS_CREATION = 27,
  CHILD_PROCESS_CREATION = 28,
  ANTI_METERPRETER = 29,
  ANTI_DETOUR = 30,
  VBSCRIPT_GENERIC = 31,
  PRIVILEGE_ESCALATION = 32,
  LSASS_PROCESS_CREATION = 33,
  PHISHING = 34,
  FRAUD = 35,
  WEB_MALWARE = 36,
  BLOCKED_WEB_CATEGORY = 37,
  BLOCKED_WEB_ACCESS = 38,
  BLOCKED_WEB_ADDRESS = 39,
  DATA_PROTECTION_EVENT = 40,
  BLACKLISTED_APPLICATION = 41,
  INITIAL_ACCESS = 42,
  CREDENTIAL_ACCESS = 43,
  DISCOVERY = 44,
  LATERAL_MOVEMENT = 45,
  CRIMEWARE = 46,
  MAIL_UNKNOWN = 47, // deprecated
  KEYLOGGER = 48,
  EMAIL_ANTIVIRUS = 49,
  EMAIL_CONTENT_FILTERING = 50,
  EMAIL_ATTACHMENT_FILTERING = 51,
  DEVICE_ALLOWED = 52, // deprecated
  DEVICE_BLOCKED = 53, // deprecated
  DEVICE_SET_TO_READ_ONLY = 54, // deprecated
  PORT_SCAN_ATTEMPT = 55,
  NETWORK_TRAFFIC_INITIATED_BY_PROCESS = 56,
  INCOMING_NETWORK_TRAFFIC = 57,
  APPLICATION_BLOCKED = 58,
  APPLICATION_ALLOWED = 59,
  CONNECTED_DEVICE = 69,
  AMSI_OBJECTS = 70,
  EXPLOIT_OTHER = 71,
  EXPLOIT_EMERGING = 72,
  EXPLOIT_DPI = 73,
  VULNERABLE_DRIVERS = 74,
  CALLBACK_EVASION = 75
}

export enum DetectingModules {
  ANTIMALWARE = 1,
  NETWORK_PROTECTION = 2,
  STORAGE_PROTECTION = 3,
  EXCHANGE_PROTECTION = 4,
  DEVICE_CONTROL = 5,
  FIREWALL = 6,
  APPLICATION_CONTROL = 7,
  ANTI_TAMPERING = 8,
}

export enum DetectingTechnologies {
  ANTIMALWARE_ON_ACCESS = 1,
  ANTIMALWARE_ON_DEMAND = 2,
  ANTIMALWARE_AVC = 3,
  ANTIMALWARE_ON_DEMAND_SCHEDULED_SCANS = 4,
  ANTIMALWARE_CONTEXTUAL_SCAN = 5,
  ANTIMALWARE_HYPER_DETECT = 6,
  ANTIMALWARE_ON_EXECUTE_FILELESS_ATTACK_PROTECTION = 7,
  ANTIMALWARE_ON_EXECUTE_ATC = 8,
  ANTIMALWARE_ADVANCED_ANTI_EXPLOIT = 9,
  NETWORK_PROTECTION_WEB_PROTECTION_ANTIPHISING = 10,
  NETWORK_PROTECTION_WEB_PROTECTION_WEB_TRAFFIC_SCAN = 11,
  NETWORK_PROTECTION_WEB_PROTECTION_HYPER_DETECT = 12,
  NETWORK_PROTECTION_CONTENT_CONTROL_WEB_ACCESS_CONTROL_CATEGORIES = 13,
  NETWORK_PROTECTION_CONTENT_CONTROL_WEB_ACCESS_CONTROL_SCHEDULER = 14,
  NETWORK_PROTECTION_CONTENT_CONTROL_WEB_ACCESS_CONTROL_EXCLUSIONS = 15,
  NETWORK_PROTECTION_CONTENT_CONTROL_DATA_PROTECTION = 16,
  NETWORK_PROTECTION_CONTENT_CONTROL_APPLICATION_BLACKLISTING = 17,
  NETWORK_PROTECTION_NETWORK_ATTACK_DEFENSE = 18,
  STORAGE_PROTECTION_STORAGE_PROTECTION = 19,
  EXCHANGE_PROTECTION_ANTIMALWARE = 20,
  EXCHANGE_PROTECTION_CONTENT_FILTERING = 21,
  EXCHANGE_PROTECTION_ATTACHEMENT_FILTERING = 22,
  DEVICE_CONTROL_DEVICE_CONTROL = 23,
  FIREWALL_PORT_SCAN = 24,
  FIREWALL_PROCESS_NETWORK_TRAFFIC = 25,
  FIREWALL_NETWORK_TRAFFIC = 26,
  APPLICATION_CONTROL_APPLICATION_CONTROL = 27,
  ANTI_TAMPERING_VULNERABLE_DRIVERS = 29,
  ANTI_TAMPERING_CALLBACK_EVASION = 30,
}

export enum FilelessAttack {
  YES = 1,
  NO = 2,
}

export interface ThreatNameWithLabelAndValue {
  [threatName: string]: { label: string; value: ThreatType };
}

export interface ThreatsWithValueAndThreatType {
  [threatName: string]: { value: number; threatType: ThreatType };
}

export interface ThreatsByDate {
  [date: string]: ThreatsWithValueAndThreatType;
}

export type QueryResultBucket = { [threatName: string]: number } & { _id: number };
export type ThreatsBucket = ThreatsWithValueAndThreatType & { _id: number };

export interface ThreatsFromInterval {
  threatsByDate: ThreatsByDate;
  threatsByDatePrevInterval: ThreatsByDate;
}
